import axios from 'axios';
export const Network = new (class Network {
    axios = axios.create({
        baseURL: '',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    request = async (url, method, data, config) => this.axios.request({
        ...config,
        url,
        method,
        data,
    });
    delete = async (url, config) => this.request(url, 'DELETE', undefined, config);
    get = async (url, config) => this.request(url, 'GET', undefined, config);
    post = async (url, data, config) => this.request(url, 'POST', data, config);
})();
